import { VueConstructor } from "vue";
import { IS_BROWSER } from "@/lib/browserUtils";

const dummyDirective = { install() {} };

export default {
  install(Vue: VueConstructor) {
    Vue.use(IS_BROWSER ? require("@/modules/validation").default : dummyDirective);
    Vue.use(IS_BROWSER ? require("@/modules/inputMask").default : dummyDirective);
    Vue.use(IS_BROWSER ? require("vue-img-orientation-changer").default : dummyDirective);
    Vue.use(IS_BROWSER ? require("vue-awesome-swiper").default : dummyDirective);
    Vue.use(IS_BROWSER ? require("@/modules/lazyLoad").default : dummyDirective);
  },
};
